<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">
            <div class="modal-title">
              <span>알림</span>
            </div>
          </slot>
        </div>
        <div class="modal-body">
          <slot name="body">
            <div class="modal-content">
              <div v-if="content" v-html="content" />
              <img
                v-if="src"
                :src="src.imageUrl"
                @click="linkTo(src.imageLink)"
              />
            </div>
          </slot>
        </div>
        <div class="btn-wrap">
          <button id="outline" @click="noMore">더 이상 보지 않기</button>
          <button @click="closeModal">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./../ModalCommon.css" scoped></style>
<style src="./layout.css" scoped></style>

<script>
/* eslint-disable */
export default {
  name: "noticeTemplate",
  props: ["content", "src"],
  methods: {
    selectAddress() {},
    closeModal() {
      this.$emit("close");
    },
    noMore() {
      this.$emit("noMore");
    },
    linkTo(url) {
      if (!url) return;
      window.open(url, "_blank");
    },
  },
  computed: {},
};

export const noticeConfig = () => {};
</script>
<style scoped>
.modal-content {
  line-height: 2;
}
</style>
